import React from "react";

import { Box, BoxProps, Span } from "@catchoftheday/cg-components";
import { styled } from "@catchoftheday/theme";

import productPriceSplit from "../../../utilities/productPriceSplit.utilities";

type ProductPricePartsProps = {
  price?: number;
  text?: string;
  normalView?: boolean;
} & BoxProps;

export const ProductPriceParts = ({
  price,
  text,
  normalView,
  ...props
}: ProductPricePartsProps) => {
  if (!price) {
    return null;
  }

  const { dollars, cents } = productPriceSplit(price, true);

  const CurrencyText = styled(Span)`
    display: inline-block;
    font-size: 0.4375em;
    line-height: 2;
    vertical-align: text-top;
  `;

  if (normalView) {
    return (
      <Box data-testid="price-parts" {...props}>
        {text && (
          <Span fontWeight="inherit" fontSize="inherit">
            {text}&nbsp;
          </Span>
        )}
        <Span fontWeight="inherit" fontSize="inherit">
          ${dollars}
          {cents && `.${cents}`}
        </Span>
      </Box>
    );
  }

  return (
    <Box data-testid="price-parts" {...props}>
      {text && (
        <Span fontWeight="inherit" fontSize="inherit">
          {text}&nbsp;
        </Span>
      )}
      <CurrencyText fontSize="inherit" fontWeight="inherit">
        $
      </CurrencyText>
      <Span fontWeight="inherit" fontSize="inherit">
        {dollars}
      </Span>
      {cents && (
        <CurrencyText fontSize="inherit" fontWeight="inherit">
          {cents}
        </CurrencyText>
      )}
    </Box>
  );
};
